import * as types from '../actions/actionTypes';
import { assign } from 'lodash';

const host = window.location.hostname
const local = (host.indexOf("local") > -1);
const staging = host.indexOf('staging') > -1;
const develop = (host.indexOf('develop.') > -1)
const ROOT_URL = (local || develop)
  ? 'https://myphoto-api-develop.appspot.com'
  : (staging)
    ? 'https://myphoto-api-staging.appspot.com'
    : 'https://mp-cloud-api.appspot.com'

const initialState = {
  results: [
    {
      name: '',
      displayName: '',
      catalogId: 0,
      disabled: false,
      subdomain: '',
      campaignId: '',
      allowPromos: false,
      startDate: '',
      endDate: '',
      debugMode: false,
    },
  ],
  salesChannel: {
    name: '',
    displayName: '',
    catalogId: 0,
    disabled: false,
    subdomain: '',
    campaignId: '',
    allowPromos: false,
    startDate: '',
    endDate: '',
    debugMode: false,
  },
  meta: {
    count: 0,
    totalCount: 0,
    pageCount: 0,
    self: `${ROOT_URL}/saleschannels?page=1`,
    previous: null,
    next: null,
    first: null,
    last: null,
    page: 1,
    limit: 20,
  },
};

function salesChannel(state = initialState, action) {
  switch (action.type) {
    case types.SALESCHANNELS_FETCH_SUCCESS:
      return assign({}, state, action.res);
    case types.SALESCHANNELS_DELETE_ERROR:
    case types.SALESCHANNELS_FETCH_ERROR:
    case types.SALESCHANNEL_FETCH_ERROR:
    case types.SALESCHANNEL_EDIT_ERROR:
    case types.SALESCHANNEL_SET_ERROR:
    case types.SALESCHANNEL_DISABLE_ERROR:
      return assign({}, state, {
        error: action.res,
      });
    case types.SALESCHANNEL_DELETE_SUCCESS:
      return assign({}, state, {
        salesChannelDelete: action.res.ok,
      });
    case types.SALESCHANNEL_FETCH_SUCCESS:
    case types.SALESCHANNEL_EDIT_SUCCESS:
    case types.SALESCHANNEL_SET_SUCCESS:
      return assign({}, state, {
        salesChannel: action.res,
      });
    case types.SALESCHANNEL_DISABLE_SUCCESS:
      return assign({}, state, {
        salesChannelDisabled: action.res.ok,
      });
    case types.SALESCHANNELS_CLEAR_ERRORS:
      return assign({}, state, {
        error: false,
      });
    default:
      return state;
  }
}

export default salesChannel;



// WEBPACK FOOTER //
// ./src/reducers/salesChannels.js